<template>
   <div class="framework-container">
      <!--heading-->
      <h2 class="heading">{{ config.header }}</h2>
      <!--framework wrapper -->
      <div class="framework-stack-wrapper">
         <!--stack(front & back) -->
         <div v-for="(item, index) in config.cards" :key="index" class="stack">
            <p class="stack__heading">{{ item.header }}</p>
            <div class="special-wrap">
               <ul class="stack__list">
                  <li
                     v-for="(val, ind) in item.ctas"
                     :key="ind"
                     class="stack__list-item"
                     @click.prevent="goTo(val.link)"
                  >
                     <a :href="val.link" class="item">
                        <div class="langicn" :class="val.icon[0]" />
                        <div class="framework-name">{{ val.header }}</div></a
                     >
                  </li>
               </ul>
            </div>
         </div>
      </div>
      <a
         v-if="!langType"
         class="btn btn-primary-grad download-cust-btn"
         :href="config.ctas[0].link"
         @click.prevent="goTo(config.ctas[0].link)"
      >
         {{ config.ctas[0].header }}
      </a>
   </div>
</template>

<script>
export default {
   name: 'IntegrateWithFrameworkEasily',
   props: {
      config: {
         type: Object,
         default: () => ({}),
      },
      langType: {
         type: Object,
         default: () => {},
      },
   },
   methods: {
      goTo(url) {
         this.$router.push(url).catch(err => {});
      },
   },
};
</script>

<style lang="scss" scoped>
.framework-container {
   .heading {
      text-align: center;
      letter-spacing: 0.41px;
      line-height: 33px;
      margin: 0 0 5rem 0;
      @media (min-width: 800px) {
         width: 695px;
         margin-left: auto;
         margin-right: auto;
      }
      @media (min-width: 992px) and (max-width: 1100px) {
         width: auto;
      }
   }
   .framework-stack-wrapper {
      .stack:first-child {
         @media (min-width: 900px) {
            .special-wrap {
               padding-right: 25px;
               border-right: 2px solid #f6f6f6;
            }
         }
      }
      .stack:last-child {
         @media (min-width: 900px) {
            .special-wrap {
               padding-left: 25px;
            }
         }
         @media (max-width: 899px) {
            margin-top: 40px;
         }
         @media (min-width: 577px) and (max-width: 899px) {
            border-top: 2px solid #f6f6f6;
            margin-top: 40px;
            padding-top: 50px;
            .stack__heading {
               margin-bottom: 36px;
            }
         }
      }
      .stack {
         display: inline-block;
         vertical-align: top;
         width: 100%;
         // border: 1px solid green;
         @media (min-width: 900px) {
            width: calc(100% / 2);
         }
         &__heading {
            margin: 0 0 36px 0;
            text-align: center;
            line-height: 20px;
            font-weight: 600;
            color: #8786a4;
            font-size: 16px;
         }

         &__list {
            list-style-type: none;
            padding: 0;
            margin: 0 -13px;
            &-item {
               transition: all 0.2s ease;
               display: inline-block;
               margin: 0 13px 20px 13px;
               height: 118px;
               width: calc(100% / 2 - 26px);
               @media (min-width: 577px) {
                  width: calc(100% / 3 - 26px);
               }
               @media (min-width: 680px) and (max-width: 899px) {
                  height: 165px;
               }
               @media (min-width: 992px) {
                  width: calc(100% / 2 - 26px);
               }
               @media (min-width: 1199px) {
                  width: calc(100% / 3 - 26px);
               }
               .item {
                  width: 100%;
                  height: 100%;
                  display: flex;
                  align-items: center;
                  flex-direction: column;
                  justify-content: center;
                  border: 1px solid black;
                  text-decoration: none;
                  box-shadow: 0 8px 10px 0 rgba(105, 87, 218, 0.06);
                  background-color: #ffffff;
                  border-radius: 4.04px;
                  border: 0.81px solid rgba(62, 57, 107, 0.04);
                  .langicn {
                     transform: scale(1.3333);
                     margin: 0;
                     @media (min-width: 680px) and (max-width: 899px) {
                        transform: scale(1.9);
                     }
                  }
                  .framework-name {
                     margin-top: 13px;
                     letter-spacing: 0.21px;
                     font-weight: 600;
                     color: #212344;
                     font-size: 14.4px;
                     @media (min-width: 680px) and (max-width: 899px) {
                        padding-top: 14px;
                     }
                  }
               }
               &:hover {
                  transform: translateY(-4px);
               }
               @media (min-width: 900px) and (max-width: 991px) {
                  &:nth-last-child(-n + 3) {
                     margin-bottom: 0;
                  }
               }
               @media (min-width: 992px) and (max-width: 1199px) {
                  &:nth-last-child(-n + 2) {
                     margin-bottom: 0;
                  }
               }
               @media (min-width: 1199px) {
                  &:nth-last-child(-n + 3) {
                     margin-bottom: 0;
                  }
               }
            }
         }
      }
   }
   .download-cust-btn {
      padding: 13px 24px;
      line-height: 16px;
      letter-spacing: 0.2px;
      font-size: 15px;
      color: #ffffff;
      display: block;
      width: 239px;
      margin: 55px auto 0 auto;
      &:hover {
         color: #ffffff;
      }
   }
}

// icon positions
.langicn-react {
   background-position: 0 -1437px;
}
.langicn-angular {
   background-position: 0 -150px;
}
.langicn-vue {
   background-position: 0 -1798px;
}
.langicn-jquery {
   background-position: 0 -1017px;
}
.langicn-ember {
   background-position: 0 -419px;
}
.langicn-php {
   background-position: 0 -1257px;
}
.langicn-dotnet {
   background-position: 0 -359px;
}
.langicn-java {
   background-position: 0 -897px;
}
.langicn-django {
   background-position: 0 -1317px;
}
.langicn-ror {
   background-position: 0 -1557px;
}
.langicn-svelte {
   background-position: 0 -1737px;
}
</style>
